<template>
    <v-card class="mx-3" outlined>
        <v-container class="pa-0">
            <v-row no-gutters>
                <v-col class="pa-3" cols="0">
                    <v-row no-gutters align="end">
                        <v-col cols="auto">
                            {{ $t('servicesystem.common_objects.store.store') }}
                        </v-col>
                        <v-col cols="0" class="pl-2">
                            <p class="mb-0">
                                <v-badge :color="badgeColor" inline class="mt-0 " dot>
                                </v-badge>
                            </p>
                        </v-col>
                        <v-col v-if="countIncreased && isOverdrawingStock && !isPurchaseOrder" cols="auto" class="pl-2">
                            <v-chip color="error" small
                                style="border-radius: 3px; margin-top: -5px; margin-bottom: -5px;">
                                {{ $t('servicesystem.common_objects.store.overdraft') }}
                            </v-chip>
                        </v-col>
                    </v-row>
                    <v-row v-if="isPurchaseOrder" no-gutters>
                        <v-col class="pt-3" style="opacity: 0.9;">
                            {{ $t('servicesystem.common_objects.store.purchase_order') }}
                        </v-col>
                    </v-row>
                    <v-row v-else no-gutters align="end">
                        <v-col cols="0">
                            <v-select v-model="storeItem" :menu-props="{ offsetY: true, top: true, maxWidth: 350 }"
                                class="mt-2" :disabled="storeLocked" :items="computedStoreItems"
                                item-value="IdCombined" return-object hide-details="auto" dense>

                                <template v-slot:selection="{ item }">
                                    {{ item.StoreName }} 
                                    <span v-if="item.StoreLocationName && item.StoreLocationName != '-' && item.StoreLocationName != item.StoreName"
                                        style="opacity: 0.8;">
                                        {{ ' / ' + item.StoreLocationName }}
                                    </span>
                                </template>

                                <template v-slot:item="{ item, attrs, on }">
                                    <v-list-item v-on="on" v-bind="attrs" dense>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <v-badge :color="item.Available > 0 ? 'green' : 'error'" inline
                                                    class="mt-0" dot>
                                                </v-badge>
                                                {{ item.StoreName }} 
                                                <span v-if="item.StoreLocationName && item.StoreLocationName != '-' && item.StoreLocationName != item.StoreName"
                                                    style="opacity: 0.8;">
                                                    {{ ' / ' + item.StoreLocationName }}
                                                </span>
                                            </v-list-item-title>
                                            <v-list-item-subtitle>
                                                {{ $t('servicesystem.common_objects.store.available') }}: {{
                                                    item.Available }}
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-select>
                        </v-col>
                        <v-col cols="auto" class="pl-2">
                            <p class="mb-0">
                                {{ available }} {{ $t('servicesystem.common_objects.store.available') }}
                            </p>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>

            <v-row v-if="canSendVendorEmail" no-gutters align="center" class="px-3 pb-3">
                <v-col cols="auto" class="ml-n1">
                    <v-checkbox v-model="vendorEmailBool" class="mt-0 pt-0" hide-details dense>
                    </v-checkbox>
                </v-col>
                <v-col cols="0" class="ml-1">
                    Send purchase order e-mail
                </v-col>
            </v-row>
            <v-row v-if="sendWareHouseEmailBool" no-gutters align="end">
                <v-col cols="12" class="px-3 pb-1">
                    The selected warehouse is not yours. <br>A stock movement e-mail will be sent to the warehouse
                    manager.
                </v-col>
                <v-col cols="12" :style="{ backgroundColor: backgroundcolor }" class="px-3 pt-2">
                    <QTextArea v-model="warehouseEmailText" externaledit clearable :backgroundcolor="backgroundcolor"
                        :label="'Your message to the warehouse manager'">
                    </QTextArea>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>


<script>
import Vue from "vue";
//import StockIndicator from "@/components/ListItems/StockIndicator.vue";

export default {
    name: "StockSelector",
    model: {
        prop: "item",
        event: "change",
    },
    props: {
        item: Object,
        StoreItems: Array,
        backgroundcolor: {
            type: String,
            default: '#f9f9f9'
        }
    },
    components: {
        //StockIndicator,
    },
    mixins: [],

    data() {
        return {
            valid: false,
            editObject: {},
        };
    },

    mounted() {
        this.editObject = Object.assign({}, this.item);

        this.ensureShouldSendVendorEmail();
    },

    methods: {
        emit() {
            this.$emit('change', this.editObject);
        },

        ensureShouldSendVendorEmail() {
            //whenever the default changes update the value if not set by user
            //console.log("ensuring should send vendor email", this.shouldSendVendorEmail);
            this.editObject.shouldSendVendorEmail = this.shouldSendVendorEmail;
            this.emit();
        },
    },

    computed: {
        badgeColor() {
            //if purchaseorder show yellow
            if (this.isPurchaseOrder) {
                return 'yellow'
            }
            else if (this.available > 0 && !this.isOverdrawingStock) {
                return 'green';
            }
            else {
                return 'error';
            }
        },

        isPurchaseOrder() {
            return !this.StoreItems?.length;
        },

        computedStoreItems() {
            if (this.isPurchaseOrder) {
                return [];
            }
            else {
                // Clone and add a unique composite key for stable identity in v-select
                var items = (this.StoreItems || []).map(x => {
                    const storeId = x.Store_Id;
                    const locId = x.StoreLocation_Id ?? '';
                    return Object.assign({}, x, { IdCombined: `${storeId}|${locId}` });
                });
                // Ensure the user's store appears even if not in the item list (normalize id comparison)
                if (!(this.StoreItems || []).some(x => (x.Store_Id?.toString()) === (this.userStoreId?.toString()))) {
                    var item = {
                        Store_Id: this.userStoreId,
                        StoreLocation_Id: null,
                        StoreName: this.userInfo.StoreName,
                        StoreLocationName: '-',
                        Available: 0,
                    };
                    item.IdCombined = `${item.Store_Id}|${item.StoreLocation_Id ?? ''}`;
                    items.unshift(item);
                    console.log("Added user store to store items", item);
                }
                return items;
            }
        },

        available() {
            const sumAvailable = this.computedStoreItems.reduce((sum, item) => {
                if (item.Store_Id === this.storeItem.Store_Id && item.StoreLocation_Id === this.storeItem.StoreLocation_Id) {
                    return sum + (parseFloat(item.Available) || 0);
                }
                return sum;
            }, 0);
            return parseFloat(sumAvailable.toFixed(2)).toString();
        },

        storeItem: {
            get() {
                var val = {
                    Store_Id: this.editObject.StoreId,
                    StoreLocation_Id: this.editObject.StoreLocationId,
                    IdCombined: `${this.editObject.StoreId}|${this.editObject.StoreLocationId ?? ''}`,
                    DisplayName: this.editObject.DisplayName,
                };
                return val;
            },
            set(value) {
                Vue.set(this.editObject, 'StoreId', value.Store_Id);
                Vue.set(this.editObject, 'StoreLocationId', value.StoreLocation_Id);
                Vue.set(this.editObject, 'DisplayName', `${value.StoreName} - ${value.StoreLocationName}`);
                this.emit();
            },
        },

        warehouseEmailText: {
            get() {
                return this.editObject.WarehouseManagerEmailMessage || '';
            },
            set(value) {
                Vue.set(this.editObject, 'WarehouseManagerEmailMessage', value);
                this.emit();
            },
        },

        storeLocked() {
            return this.$store.state.GlobalSettings.TechnicianLimitSelectToOwnStore;
        },

        //wrapper to keep the initial stock ids from when detail was fethced
        exisitngStockTracking() {
            return this.item.exisitngStockTracking || {
                ArticleCount: 0,
                WareHouseId: null,
                StoreLocationId: null
            };
        },

        stockIsMeaningfullyChanged() {
            var bool = this.warehouseChanged || this.warehouseLocationChanged || this.countIncreased; //we dont care about decreases witin the same storeitem as they wont need to order more stock
            console.log("stockIsMeaningfullyChanged:", bool);
            if (this.warehouseChange) {
                console.log(" - wareHouse changed from", this.exisitngStockTracking.StoreId, "to", this.editObject.StoreId);
            }
            if (this.warehouseLocationChanged) {
                console.log(" - storeLocation changed from", this.exisitngStockTracking.StoreLocationId, "to", this.editObject.StoreLocationId);
            }
            if (this.countIncreased) {
                console.log(" - count increased from", this.exisitngStockTracking.ArticleCount, "to", this.editObject.ArticleCount);
            }
            return bool;
        },

        countIncreased() {
            return this.exisitngStockTracking.ArticleCount < this.editObject.ArticleCount;
        },

        warehouseChanged() {
            return this.exisitngStockTracking.WareHouseId !== this.editObject.StoreId;
        },

        warehouseLocationChanged() {
            return this.exisitngStockTracking.StoreLocationId !== this.editObject.StoreLocationId;
        },

        isOverdrawingStock() {
            return this.item.ArticleCount > this.available;
        },

        userStoreId() {
            return this.userInfo.StoreId;
        },

        sendWareHouseEmailBool() {
            //if from is set you can send warehouse email
            var enabled = this.$store.state.GlobalSettings.WarehouseManagerEmailFrom;
            return enabled && this.editObject.StoreId != this.userStoreId && this.stockIsMeaningfullyChanged;
        },
        warehouseEmailTo() {
            return this.$store.state.GlobalSettings.WarehouseManagerEmailTo;
        },

        canSendVendorEmail() {
            //if to is set you can send vendor email
            return this.$store.state.GlobalSettings.VendorOrderEmailTo && this.stockIsMeaningfullyChanged;
        },
        shouldSendVendorEmail() {
            return this.countIncreased && this.isOverdrawingStock;
        },
        vendorEmailBool: {
            get() {
                //only calculate default value when undefined
                if (this.editObject.SendVendorEmail === undefined) {
                    return this.shouldSendVendorEmail;
                }
                else {
                    return this.editObject.SendVendorEmail;
                }
            },
            set(value) {
                Vue.set(this.editObject, 'SendVendorEmail', value);
                this.emit();
            },
        },
    },

    watch: {
        item: {
            handler(newValue) {
                this.editObject = Object.assign({}, newValue);
            },
            deep: true,
        },
        shouldSendVendorEmail() {
            //whenever the default changes update the value if not set by user
            this.ensureShouldSendVendorEmail();
        },
    },
};
</script>

<style lang="scss"></style>